import { PathOptions } from "leaflet";

export const terras_indigenas_homologadas = (feature: any): PathOptions => {
  return {
    color: "#fe6450ff",
    weight: 1.5,
    opacity: 1,
  };
};
